/**
 * De lijndikte van een tekentje.
 *
 * Elk icoon in de app staat op een viewBox van 24. Om er op het scherm overal
 * dezelfde 2,2 pixels van te maken moet de opgegeven dikte meeschalen met de maat
 * waarop je hem tekent: een klein icoon vraagt een dikkere lijn.
 *
 * Deze som stond op drie plekken los in de code en vijftien iconen volgden hem niet.
 * Hij hoort hier te staan en nergens anders. Zie sectie 8 van CLAUDE.md.
 */
export const ICON_DIKTE = 2.2;

export function iconStroke(maat) {
  return Math.round(ICON_DIKTE * 24 / maat * 10) / 10;
}
